import { render, staticRenderFns } from "./PanelViewMenuItem.vue?vue&type=template&id=69803036&"
import script from "./PanelViewMenuItem.vue?vue&type=script&lang=js&"
export * from "./PanelViewMenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports